import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Navbar from '../components/Navbar/Navbar';

const Root = () => {
    return (
        <div>
            <Navbar></Navbar>
            <Outlet></Outlet>
            <Footer></Footer>
        </div>
    );
};

export default Root;